export enum EvaluationType {
  PHYSICAL = 'PHYSICAL',
  VIDEO = 'VIDEO',
  REMOTE = 'REMOTE',
}
